{
    const dropdown = document.querySelector('.knowledge-dropdown');
    const select = dropdown.querySelector('.knowledge-dropdown__select');
    const items = dropdown.querySelectorAll('.knowledge-dropdown__item');
    const types = dropdown.querySelectorAll('.knowledge-dropdown__type');
    const links = dropdown.querySelectorAll('.knowledge-dropdown__link');

    // toggle dropdown
    select.addEventListener('click', () => {
       dropdown.classList.toggle('knowledge-dropdown_open');
    });

    // toggle menu types
    types.forEach(type => {
        const parent = type.parentElement;
        const submenu = type.nextElementSibling;

        if (submenu) {
            parent.classList.add('has-submenu');

            type.addEventListener('click', (e) => {
                items.forEach(item => item.classList.remove('is-open'));
                parent.classList.toggle('is-open');
            });
        }
    });

    links.forEach(link => {
        const parent = link.closest('.has-submenu');
        if (link.matches('.is-active')) parent.classList.add('is-open');
    });
}